<template>
	<!-- Gallery -->
	<modal
		wrapper="full"
		size="full"
		class="template-modal popup-modal"
		@close="close"
		:hide-footer="true"
		>
		<!-- <template slot="header">
		</template> -->
		<template slot="body">
			<div class="row program-monitor">
			<!-- List category -->
				<!-- Button Action -->
					<div class="w-100 flex-center-left pr-4 pl-4">
						<!-- bottom navbar -->
						<div v-if="!isOpenUploadNonAdmin" class="flex-center-left floating-bottom-navbar mb-2 mr-5">
							<!-- Search Keyword -->
							<div class="relative">
								<i class="material-icons wrapper-search-input">search</i>
								<input
									type="text"
									class="form-control search-input"
									:placeholder="$t('Search Template')"
									@input="onKeywordChange"
									v-model="keyword"/>
							</div>
							<!-- favorite -->
							<div
								class="ml-4 mr-1 pointer uppercase pb-1"
								:class="{ 'active': tab === 'favorite', 'text-primary': tab === 'favorite' }"
								v-tooltip.top="$t('Favorite')"
								@click="goFavorite">
								<!-- <svg v-if="tab === 'favorite'" style="width:32px;height:32px" viewBox="0 0 24 24">
									<path fill="#FFA800" d="M12,17.27L18.18,21L16.54,13.97L22,9.24L14.81,8.62L12,2L9.19,8.62L2,9.24L7.45,13.97L5.82,21L12,17.27Z" />
								</svg> -->
								<!-- <svg v-if="tab !== 'favorite'" style="width:32px;height:32px" viewBox="0 0 24 24">
									<path fill="grey" d="M12,17.27L18.18,21L16.54,13.97L22,9.24L14.81,8.62L12,2L9.19,8.62L2,9.24L7.45,13.97L5.82,21L12,17.27Z" />
								</svg> -->
								<img v-if="tab === 'favorite'" src="/img/star-orange.png" alt="xls" width="25px;"/>
								<img v-if="tab !== 'favorite'" src="/img/unfavorite.png" alt="xls" width="25px;"/>
							</div>
							<!-- filtering -->
							<div
								class="pointer ml-4 mr-4 uppercase" @click="sortRecent" :class="{'text-primary': orderBy === 'created_at' && tab !== 'favorite'}">
								{{ $t('Recent') }}
							</div>
							<div
								class="pointer uppercase ml-1 mr-4" @click="sortAlphabetical" :class="{'text-primary': orderBy === 'name' && tab !== 'favorite'}">
								{{ $t('Alphabetical') }}
							</div>
							<div v-if="isSuperAdmin"
								class="pointer mr-4 uppercase" @click="filterByAdmin" :class="{'text-primary': isByAdmin}">
								{{ $t('By Admin') }}
							</div>
							<!-- select -->
							<div class="ml-a">
								<button v-if="selected"
									type="button"
									class="btn btn-primary mb-0 ml-3 mr-3"
									@click="dblCliclSelectItem(selected)">
									{{ $t('Select') }}
								</button>
							</div>
							<!-- edit button -->
							<div>
								<button
									v-if="(selected && (tab === 'all') && user.roles.includes('super_admin')) || (selected && (tab === 'all') && (selected.user_id === user.id))"
									type="button"
									class="btn btn-primary"
									@click="editInAllTab">
									{{ $t('Edit Selected') }}
								</button>
							</div>
							<div>
								<button
									v-if="(selected && (tab === 'favorite') && user.roles.includes('super_admin'))"
									type="button"
									class="btn btn-primary ml-3 "
									@click="editInFavoriteTab">
									{{ $t('Edit Selected') }}
								</button>
							</div>
							<!-- delete -->
							<div @click="isConfirmRemoveVisible = true">
								<div v-if="selected && user.roles.includes('super_admin') || (selected && (tab === 'all') && user.roles.includes('super_admin') && (activeRouteName === 'RundownCommandEditor' || activeRouteName === 'RundownEditor')) || (selected && (tab === 'all') && (selected.user_id === user.id))">
									<label
										:class="{'is-loading': isDeleting, '': (activeRouteName === 'RundownEditor' || activeRouteName === 'RundownCommandEditor'), 'disabled': !selected}"
										v-tooltip.bottom-end="$t('Delete Selected')"
										class="btn btn-danger btn-icon ml-3 button-upload-lottie-gallery btn-gallery-small">
										<i class="material-icons md-18">delete</i>
									</label>
								</div>
							</div>
							<!-- Assign to user -->
							<div @click="openModalAssignUser(selected)">
								<div v-if="(selected && user.roles.includes('super_admin')) && (user && selected.user_id === user.id)">
									<label
										v-tooltip.bottom-end="$t('Assign to user')"
										class="btn btn-primary btn-icon ml-3 button-upload-lottie-gallery btn-gallery-small">
										<i class="material-icons md-18">people</i>
									</label>
								</div>
							</div>
							<div v-if="isSuperAdmin">
								<modal-assign-user :titleAssignModal="'template'" :data="dataMediaToAssign" :isShowAssign="isShowAssign" @close="isShowAssign = false"/>
							</div>
						</div>
						<!-- add new admin -->
						<div
							class="pointer text-upload-gallery"
							v-if="user.roles.includes('super_admin') && rundownItem
							&& rundownItem.type !== 'timer' && rundownItem.type !== 'ticker' || (activeRouteName !== 'RundownEditor' && activeRouteName !== 'RundownCommandEditor')"
							@click="goToTemplatesEditor()">
							{{ $t('UPLOAD CUSTOM TEMPLATE') }}
						</div>
						<!-- add new non admin -->
						<div
							class="pointer text-upload-gallery"
							v-if="(!user.roles.includes('super_admin') && userUploadTemplates) && rundownItem
							&& rundownItem.type !== 'timer' && rundownItem.type !== 'ticker'"
							@click="goToTemplatesEditorNonAdmin()">
							{{ $t('UPLOAD CUSTOM TEMPLATE') }}
						</div>
						<div @click="scroll_left">
							<svg class="icon-chevron" style="width:24px;height:24px" viewBox="0 0 24 24">
								<path d="M15.41,16.58L10.83,12L15.41,7.41L14,6L8,12L14,18L15.41,16.58Z" />
							</svg>
						</div>
						<!-- category -->
						<div ref="scrollCategoryTemplate" class="form-group mb-3 mt-3 mr-3 d-flex scrolling-horizontal-menu uppercase">
							<div class="mr-2" v-for="item in categories" :key="item.id">
								<div class="category-gallery nowrap pointer"  :class="{'category-gallery-active': categoryId && item.id === categoryId}" @click="selectedCategory(item)">{{item.name}}</div>
							</div>
							<!-- <select
								name="size"
								class="form-control category-template-input"
								required
								@change="selectedCategory(category)"
								v-model="category">
								<option :value="'all'">
									All
								</option>
								<option
									v-for="item in categories"
									:key="item.id"
									:value="item.id">
									{{ item.name }}
								</option>
							</select> -->
						</div>
						<div @click="scroll_right">
							<svg class="icon-chevron" style="width:24px;height:24px" viewBox="0 0 24 24">
								<path d="M8.59,16.58L13.17,12L8.59,7.41L10,6L16,12L10,18L8.59,16.58Z" />
							</svg>
						</div>
						<!-- store -->
						<!-- <div
							class="ml-4 mr-3 pointer uppercase"
							:class="{ 'active': tab === 'store', 'text-primary': tab === 'store' }"
							@click="goStore">
							{{ $t('Store') }}
						</div> -->
					</div>
					<div class="col-md-8">
						<div class="tab-contents">
							<!-- Loader -->
							<div>
								<div class="p-5 text-center top-50p absolute z-index-99 left50" v-if="isFetching">
									<div class="is-loading large loader-popup"></div>
								</div>
							</div>
							<!-- Template Grid -->
							<div class="template-editor-wrapper " v-if="tab === 'all' || tab === 'favorite'">
								<transition name="fade" >
									<div @scroll="lazyLoad" class="templates template-editor-item" id="styleScroll" >
										<div
											class="template d-block"
											:class="{ 'active': selected && selected.id === template.id }"
											v-for="template in filteredItem"
											:key="template.id"
											@dblclick="dblCliclSelectItem(template)"
											@click="selectItem(template)">
											<!-- favorite / unfavorite -->
											<div class="d-flex justify-content-between relative">
												<template-popup-image-thumbnail :template="template"/>
												<!-- <div v-if="template.img_path">
													<img :src="template.img_path" class="absolute thumbnail-template" alt="Grafias">
												</div>
												<div v-else>
													<img src="/img/TemplateThumbnailDefault_01.png" class="absolute thumbnail-template" alt="Grafias">
												</div> -->
												<div></div>
												<div class="absolute mr-1 mt-1 icon-favorite-position"
													v-if="tab === 'all' && template && template.__meta__ && template.__meta__.is_favorite === 1" @click.stop="removeFavorite(template.id)">
													<img src="/img/favorite.png" alt="xls" width="15px;"/>
												</div>
												<div class="absolute mr-1 mt-1 icon-favorite-position"
													v-if="tab === 'all' && template && template.__meta__ && template.__meta__.is_favorite === 0" @click.stop="addToFavorite(template.id)">
													<img src="/img/unfavorite.png" alt="xls" width="15px;"/>
												</div>
											</div>
											<div
												class="template-thumbnail"
												:style="{ backgroundImage: `url(${template.path})` }">
											</div>
											<div class="btn-wrapper-template">
												<div
													class="template-btn-select truncate-media-name uppercase">
													{{ template && template.name }}
												</div>
											</div>
										</div>
									</div>
								</transition>
							</div>
							<div v-if="items.length <= 0 && !isFetching && tab !== 'store'" class="template-editor-wrapper text-center">
								<div>
									<h4>{{$t('No Available Template')}}</h4>
								</div>
							</div>
							<div class="template-editor-wrapper text-center mt-35"  v-if="tab === 'store'">
								<div>
									<h4>{{$t('Stay Tuned')}}</h4>
								</div>
							</div>
						</div>
					</div>
					<div @click="close"  class="modal-close-media-template">
						<i class="material-icons font15">close</i>
					</div>
					<!-- preview -->
					<div class="col-md-4 category-filter pr-3 pl-0" id="styleScroll">
						<div class="preview-template2 mb-3">
							<TemplatePreview ref="templatePreview" class="preview-template2" :template="activeTemplate" :lottieTemplate="activeLottie" :data="selected"/>
						</div>
						<div class="mb-3" v-if="selected">
							<button
								type="button"
								class="btn btn-primary w-100"
								@click="dblCliclSelectItem(selected)">
								{{ $t('Select Template') }}
							</button>
						</div>
						<h4 v-if="selected" class="uppercase text-white mb-5">{{ selected && selected.name ? selected.name : '' }}</h4>
						<div v-if="selected && tab === 'all'" class="text-left capitalize">
							<div v-if="selected" class="text-left capitalize mb-5">
								<div class="d-flex mb-3">
									<svg class="mr-3" style="width:27;height:27" viewBox="0 0 22 22">
										<path fill="#717171" d="M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2M7.07,18.28C7.5,17.38 10.12,16.5 12,16.5C13.88,16.5 16.5,17.38 16.93,18.28C15.57,19.36 13.86,20 12,20C10.14,20 8.43,19.36 7.07,18.28M18.36,16.83C16.93,15.09 13.46,14.5 12,14.5C10.54,14.5 7.07,15.09 5.64,16.83C4.62,15.5 4,13.82 4,12C4,7.59 7.59,4 12,4C16.41,4 20,7.59 20,12C20,13.82 19.38,15.5 18.36,16.83M12,6C10.06,6 8.5,7.56 8.5,9.5C8.5,11.44 10.06,13 12,13C13.94,13 15.5,11.44 15.5,9.5C15.5,7.56 13.94,6 12,6M12,11A1.5,1.5 0 0,1 10.5,9.5A1.5,1.5 0 0,1 12,8A1.5,1.5 0 0,1 13.5,9.5A1.5,1.5 0 0,1 12,11Z" />
									</svg>
									<div class="mt-2 text-white">{{selected && selected.user && selected.user.name ? selected.user.name: 'User Has Been Deleted'}}</div>
								</div>
							</div>
						</div>
						<div v-if="selected && tab === 'favorite'" class="text-left capitalize">
							<div v-if="selected" class="text-left capitalize mb-5">
								<div class="d-flex mb-3">
									<svg class="mr-3" style="width:27;height:27" viewBox="0 0 22 22">
										<path fill="#717171" d="M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2M7.07,18.28C7.5,17.38 10.12,16.5 12,16.5C13.88,16.5 16.5,17.38 16.93,18.28C15.57,19.36 13.86,20 12,20C10.14,20 8.43,19.36 7.07,18.28M18.36,16.83C16.93,15.09 13.46,14.5 12,14.5C10.54,14.5 7.07,15.09 5.64,16.83C4.62,15.5 4,13.82 4,12C4,7.59 7.59,4 12,4C16.41,4 20,7.59 20,12C20,13.82 19.38,15.5 18.36,16.83M12,6C10.06,6 8.5,7.56 8.5,9.5C8.5,11.44 10.06,13 12,13C13.94,13 15.5,11.44 15.5,9.5C15.5,7.56 13.94,6 12,6M12,11A1.5,1.5 0 0,1 10.5,9.5A1.5,1.5 0 0,1 12,8A1.5,1.5 0 0,1 13.5,9.5A1.5,1.5 0 0,1 12,11Z" />
									</svg>
									<div class="mt-2 text-white" v-if="tab !== 'favorite'">{{selected && selected.user && selected.user.name ? selected.user.name : 'User Has Been Deleted'}}</div>
									<div class="mt-2 text-white" v-if="tab === 'favorite'">{{selected && selected.user_name ? selected.user_name : 'User Has Been Deleted'}}</div>
								</div>
							</div>
						</div>
						<!-- desctription -->
						<div v-if="selected" @blur="saveDescription">
							<hr v-if="selected && selected.description || selected.user_id === user.id">
							<div class="d-flex justify-content-between" v-if="selected && selected.description || selected.user_id === user.id">
								<h4>Description</h4>
									<i class="material-icons md-18 pointer" v-tooltip="'Edit description'" @click.stop="isEditDescription = true" v-if="!isEditDescription && selected.user_id === user.id">edit</i>
							</div>
							<div class="relative" v-if="selected && selected.description || selected.user_id === user.id">
								<div class="ml-1 text-left absolute" v-if="!isEditDescription && !selected.description">-</div>
								<textarea @blur="saveDescription" :class="{'textarea-feedback': isEditDescription, 'textarea-idle': !isEditDescription, 'disabled': selected.user_id !== user.id}" @click="isEditDescription = true" rows="8" v-model="selected.description"></textarea>
							</div>
							<transition name="fade">
								<button
									v-if="selected && isEditDescription"
									type="button"
									class="btn btn-primary w-100 mt-2"
									@click="saveDescription">
									{{ $t('Update Description') }}
								</button>
							</transition>
						</div>
					</div>
				</div>
			<!-- Delete Confirmation -->
			<modal
				size="small"
				class="template-modal gallery-modal-delete"
				@close="isConfirmRemoveVisible = false"
				v-if="isConfirmRemoveVisible">
				<template slot="header">
					{{ $t('Confirm Delete') }}
				</template>
				<template slot="body">
					A<span class="lowercase pr-1">{{ $t('re you sure want to delete') }}</span><span class="capitalize">{{showModalName(selected ? selected.name : '') }}?</span>
				</template>
				<template slot="footer">
					<div class="w-100 flex-center">
						<button class="btn btn-primary" :class="{ 'is-loading': isDeleting }" @click="remove">
							{{ $t('Yes, Delete It') }}
						</button>
						<button class="btn btn-default" @click="isConfirmRemoveVisible = false">
							{{ $t('Cancel') }}
						</button>
					</div>
				</template>
			</modal>
			<!-- User Form -->
			<upload-lottie-non-admin
				:update="isUpdateNonAdmin"
				:data="selected"
				@saved="insertItemsNonAdmin"
				@close="closeModalNonAdminUpload"
				v-if="isOpenUploadNonAdmin"
			/>
		</template>
	</modal>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import readXlsxFile from 'read-excel-file';
import localforage from 'localforage';
import Modal from '@/components/Modal.vue';
import ModalAssignUser from '@/components/ModalAssignUser.vue';
import {
	getAxiosErrorMessage,
	delay,
	elpisisString,
	getVideoBlob,
	duplicateVar,
	dateFormat,
} from '@/lib/helper';
import {
	templateSchema,
} from '@/lib/statics';
import TemplatePreview from '@/components/TemplatePreview.vue';
import UploadLottieNonAdmin from '@/components/UploadLottieNonAdmin.vue';
import templatesApi from '@/api/templates';
import templateFavoritesApi from '@/api/template-favorites';
import categoriesApi from '@/api/categories';
import authApi from '@/api/auth';
import TemplatePopupImageThumbnail from '@/components/TemplatePopupImageThumbnail.vue';

export default {
	name: 'TemplatePopup',
	props: {
		rundownItem: {
			type: Object,
		},
	},
	sockets: {
		update(payload) {
			this.clearThumbnail(payload);
			delay(() => {
				this.insertTemplate(payload);
			}, 1600);
		},
		create(payload) {
			this.insertTemplate(payload);
		},
	},
	components: {
		Modal,
		TemplatePreview,
		UploadLottieNonAdmin,
		TemplatePopupImageThumbnail,
		ModalAssignUser,
	},
	data() {
		return {
			tab: 'all', // event, all
			page: 1,
			limit: 1000,
			orderBy: 'created_at',
			sortBy: 'desc',
			lastPage: 0,
			keyword: '',
			items: [],
			selected: null,
			isFetching: false,
			isUploading: false,
			uploadProgress: 0,
			mediaUrl: '',
			mediaFile: null,
			mediaLabel: '',
			isAdding: false,
			isDeleting: false,
			isFavorite: false,
			isImporting: false,
			categories: [],
			category: 'all',
			isSelectedCategory: false,
			categoryId: -10,
			storeTab: false,
			previewTemplate: {},
			images: [
				'https://grafias-medias.s3.eu-central-1.amazonaws.com/img/TemplateThumbnailDefault_01.jpg',
				'https://grafias-medias.s3.eu-central-1.amazonaws.com/img/TemplateThumbnailDefault_02.jpg',
				'https://grafias-medias.s3.eu-central-1.amazonaws.com/img/TemplateThumbnailDefault_03.jpg',
				'https://grafias-medias.s3.eu-central-1.amazonaws.com/img/TemplateThumbnailDefault_04.jpg',
			],
			isConfirmRemoveVisible: false,
			bottom: false,
			limitLazyload: 42,
			isOpenUploadNonAdmin: false,
			isUpdateNonAdmin: false,
			// caching
			cachingText: 'Loading ',
			totalCached: 0,
			cancelRequest: null,
			cancelRequestArray: [],
			cancelActive: false,
			showLoadingScreen: true,
			counter: 0,
			dataMediaToAssign: {},
			isShowAssign: false,
			settings: null,
			isEnableAdvance: false,
			isEnableDummy: true,
			isEnableAllPreview: false,
			isEnableShowLogo: false,
			lastCategoryTemplate: 0,
			lastKeywordTemplate: '',
			isShowTour: false,
			lastCategoryGallery: 0,
			lastKeywordGallery: '',
			isByAdmin: false,
			// description
			isEditDescription: false,
			description: '',
		};
	},
	methods: {
		...mapActions({
			setUser: 'setUser',
		}),
		lazyLoad(e) {
			const { target } = e;
			if (this.page < this.lastPage) {
				if (Math.ceil(target.scrollTop) >= (target.scrollHeight - target.offsetHeight)) {
					this.bottom = true;
					this.page++;
					this.fetch(false, true);
				}
			}
		},
		randomImage(items) {
			return items[Math.floor(Math.random() * items.length)];
		},
		close() {
			this.$emit('close');
		},
		startCache() {
			const templates = this.items.filter(item => ((item.type === 'lower_third' || item.type === 'timer' || item.type === 'ticker')));
			// If no media (image or video)
			// if (templates.length === 0) this.initScreen();
			// Cache
			for (let index = 0; index < templates.length; index++) {
				if (this.cancelActive) return;
				const item = templates[index];
				const contentId = item.id;
				const itemKey = `thumbnail_template_${contentId}`;
				// if ((item.type === 'image' || item.type === 'video') && content && content.id) itemKey = `thumbnail_${content.id}`;
				// if (item.type === 'lottie' && content && content.id) itemKey = `thumbnail_${content.id}`;
				// eslint-disable-next-line no-loop-func
				localforage.getItem(itemKey, (err, value) => {
					if (value) {
						// logic when no value
					} else {
						const itemMediaThumbnail = item && item.img_path ? item.img_path : '/img/TemplateThumbnailDefault_01.jpg';
						const itemMediaName = item && item.name ? item.name : 'template';
						if (itemMediaThumbnail) {
							this.cacheFile(itemKey, itemMediaThumbnail, itemMediaName);
						}
					}
				});
			}
		},
		cacheFile(galleryKey, itemMediaPath, itemMediaName) {
			// get media assets as blob....
			try {
				const cancelCallback = (c) => {
					this.cancelRequest = c;
					this.cancelRequestArray.push(c);
				};
				getVideoBlob(itemMediaPath, cancelCallback).then((blob) => {
					// Check videoBlob
					if (this.cancelActive) return;
					if (!blob) return;
					// Set key and blob
					localforage.setItem(galleryKey, blob, (err, value) => {
						if (!err && value) {
							// handle success cache here
						}
						if (err) {
							this.$notify({
								duration: 6000,
								closeOnClick: true,
								group: 'app',
								type: 'error',
								title: 'Error loading media',
								text: 'Something went wrong please contact admin!',
							});
						}
					});
				}).catch(() => {
					// error handling logic
					const message = `Template: ${itemMediaName}. Sorry, some media file can't be loaded or media not found, please check`;
					this.$notify({
						duration: 6000,
						closeOnClick: true,
						group: 'app',
						type: 'error',
						title: 'Error loading Template',
						text: message,
					});
				});
			} catch (e) {
				// catch some error here
			}
		},
		fetch(reset = false, isLazyLoad) {
			// condition limit for various screen
			const widthScreen = window.innerWidth;
			if (widthScreen <= 1920) {
				this.limitLazyload = 48;
				if (window.innerHeight > 1000) this.limitLazyload = 65;
				if (window.innerHeight > 1150) this.limitLazyload = 80;
			} else if (widthScreen <= 1920 && widthScreen > 1920) {
				this.limitLazyload = 60;
				if (window.innerHeight > 1150) this.limitLazyload = 80;
			} else if (widthScreen <= 2400 && widthScreen > 2000) {
				this.limitLazyload = 70;
				if (window.innerHeight > 1150) this.limitLazyload = 80;
			} else if (widthScreen <= 2600 && widthScreen > 2000) {
				this.limitLazyload = 80;
			} else if (widthScreen <= 2900 && widthScreen > 2000) {
				this.limitLazyload = 100;
			} else if (widthScreen <= 3440 && widthScreen > 2900) {
				this.limitLazyload = 120;
			} else if (widthScreen <= 4096 && widthScreen > 3440) {
				this.limitLazyload = 150;
			}
			// coding fetch begin
			this.isFetching = true;
			this.selected = null;
			if (reset) {
				this.page = 1;
				this.items = [];
			}
			let type = '';
			if (this.rundownItem) {
				type = this.rundownItem.type;
			}
			const params = {
				page: this.page,
				limit: this.limitLazyload,
				order_by: this.orderBy,
				sort_by: this.sortBy,
				type,
			};
			if (this.categoryId === -10 || !this.categoryId) params.category_id = '';
			if (this.categoryId !== -10) params.category_id = this.categoryId;
			const keyword = this.keyword.trim();
			if (keyword !== '') {
				params.keyword = keyword;
			}
			if (this.isByAdmin) params.role = this.isByAdmin;
			const callback = (response) => {
				const templates = response.data;
				this.lastPage = response.lastPage;
				if (isLazyLoad) {
					this.insertItems(templates);
				} else {
					this.items = templates;
				}
				this.startCache();
				this.isFetching = false;
			};
			const errorCallback = (e) => {
				const message = getAxiosErrorMessage(e);
				this.$notify({
					group: 'app',
					type: 'error',
					title: 'Templates',
					text: message,
				});
				this.isFetching = false;
			};
			if (this.tab === 'all') {
				templatesApi.getList(params, callback, errorCallback);
			} else if (this.tab === 'favorite') {
				templateFavoritesApi.getList(params, callback, errorCallback);
			} else {
				this.isFetching = false;
				this.storeTab = true;
			}
		},
		onKeywordChange() {
			delay(() => {
				this.fetch(true);
				this.updateSettingProfile();
			}, 500);
		},
		saveDescription() {
			this.isEditDescription = false;
			const callback = () => {
			};
			const errorCallback = (e) => {
				const message = getAxiosErrorMessage(e);
				this.$notify({
					group: 'app',
					type: 'error',
					title: 'Add Templates',
					text: message,
				});
			};
			const params = {
			};
			if (this.selected.description) params.description = this.selected.description;
			templatesApi.update(this.selected.id, params, callback, errorCallback);
		},
		selectItem(item) {
			if (this.selected && item.id === this.selected.id) {
				this.selected = null;
				this.previewTemplate = null;
			} else {
				this.selected = item;
				const contentParse = JSON.parse(item.content);
				const content = {
					content: contentParse.content,
					style: contentParse.style,
					script: contentParse.script,
				};
				this.previewTemplate = content;
			}
			if (!item.description) this.isEditDescription = false;
		},
		dblCliclSelectItem(item) {
			if (this.activeRouteName !== 'RundownEditor' && this.activeRouteName !== 'RundownCommandEditor') {
				const routeData = this.$router.resolve(`/templates/${item.id}`);
				window.open(routeData.href, '_blank');
				this.$emit('goToTemplatesEditor');
				if (!this.user.roles.includes('super_admin')) {
					this.$emit('goToTemplatesEditorNonAdmin');
				}
			} else {
				this.selected = item;
				this.$emit('select', this.selected);
			}
		},
		select() {
			this.$emit('select', this.selected);
		},
		remove() {
			if (!this.selected) return;
			this.isDeleting = true;
			const id = this.selected.id;
			const callback = (response) => {
				this.removeItem(id);
				this.selected = null;
				const message = response.message;
				this.$notify({
					group: 'app',
					type: 'success',
					title: 'Delete Templates',
					text: message,
				});
				this.isDeleting = false;
				this.isConfirmRemoveVisible = false;
			};
			const errorCallback = (e) => {
				const message = getAxiosErrorMessage(e);
				this.$notify({
					group: 'app',
					type: 'success',
					title: 'Delete Templates',
					text: message,
				});
				this.isDeleting = false;
				this.isConfirmRemoveVisible = false;
			};
			templatesApi.delete(id, callback, errorCallback);
		},
		removeItem(itemId) {
			const index = this.items.findIndex(({ id }) => id === itemId);
			if (index !== -1) {
				this.items.splice(index, 1);
			}
		},
		goToTemplatesEditor() {
			const routeData = this.$router.resolve('/templates/new');
			window.open(routeData.href, '_blank');
			this.$emit('goToTemplatesEditor');
		},
		goToTemplatesEditorNonAdmin() {
			// const routeData = this.$router.resolve('/lotties/new');
			// window.open(routeData.href, '_blank');
			this.isOpenUploadNonAdmin = true;
			this.$emit('goToTemplatesEditorNonAdmin');
		},
		closeModalNonAdminUpload() {
			this.isOpenUploadNonAdmin = false;
			this.isUpdateNonAdmin = false;
		},
		editInAllTab() {
			if (!this.user.roles.includes('super_admin')) {
				// const id = this.selected.id;
				// const routeData = this.$router.resolve(`/lotties/${id}`);
				// window.open(routeData.href, '_blank');
				this.isUpdateNonAdmin = true;
				this.isOpenUploadNonAdmin = true;
			} else {
				const id = this.selected.id;
				const routeData = this.$router.resolve(`/templates/${id}`);
				window.open(routeData.href, '_blank');
				this.$emit('goToTemplatesEditor');
			}
		},
		editInFavoriteTab() {
			if (!this.user.roles.includes('super_admin')) {
				const id = this.selected.template_id;
				const routeData = this.$router.resolve(`/lotties/${id}`);
				window.open(routeData.href, '_blank');
				this.$emit('goToTemplatesEditor');
			} else {
				const id = this.selected.template_id;
				const routeData = this.$router.resolve(`/templates/${id}`);
				window.open(routeData.href, '_blank');
				this.$emit('goToTemplatesEditor');
			}
		},
		addToFavorite(id) {
			this.isSaving = true;
			const callback = (response) => {
				const item = response.data;
				const index = this.items.findIndex(({ id }) => id === item.template_id);
				if (index !== -1) {
					this.items[index].__meta__.is_favorite = 1;
				}
				const message = response.message;
				this.$notify({
					group: 'app',
					type: 'success',
					title: 'Template',
					text: message,
				});
				this.isSaving = false;
			};
			const errorCallback = (e) => {
				const message = getAxiosErrorMessage(e);
				this.$notify({
					group: 'app',
					type: 'error',
					title: 'Template',
					text: message,
				});
				this.isSaving = false;
			};
			templateFavoritesApi.create(id, callback, errorCallback);
		},
		removeFavorite(idTemplate) {
			this.isSaving = true;
			const callback = (response) => {
				const index = this.items.findIndex(({ id }) => id === idTemplate);
				if (index !== -1) {
					this.items[index].__meta__.is_favorite = 0;
				}
				const message = response.message;
				this.$notify({
					group: 'app',
					type: 'success',
					title: 'Template',
					text: message,
				});
				this.isSaving = false;
			};
			const errorCallback = (e) => {
				const message = getAxiosErrorMessage(e);
				this.$notify({
					group: 'app',
					type: 'error',
					title: 'Template',
					text: message,
				});
				this.isSaving = false;
			};
			templateFavoritesApi.delete(idTemplate, callback, errorCallback);
		},
		importItems(e) {
			const files = e.target.files;
			if (files.length > 0) {
				const file = files[0];
				readXlsxFile(file, { schema: templateSchema }).then(({ rows, errors }) => {
					if (errors.length === 0) {
						const templates = rows;
						this.createBulk(templates);
					}
				});
			}
		},
		createBulk(items) {
			this.isImporting = true;
			const callback = (response) => {
				const items = response.data;
				this.insertItems(items);
				const message = response.message;
				this.$notify({
					group: 'app',
					type: 'success',
					title: 'Import Templates',
					text: message,
				});
				this.isImporting = false;
			};
			const errorCallback = (e) => {
				const message = getAxiosErrorMessage(e);
				this.$notify({
					group: 'app',
					type: 'error',
					title: 'Import Templates',
					text: message,
				});
				this.isImporting = false;
			};
			templatesApi.createBulk(items, callback, errorCallback);
		},
		insertItems(items) {
			for (let index = 0; index < items.length; index++) {
				const item = items[index];
				this.items.push(item);
			}
		},
		insertItemsNonAdmin(items) {
			for (let index = 0; index < items.length; index++) {
				const item = items[index];
				this.items.push(item);
			}
			if (this.activeRouteName === 'RundownEditor' || this.activeRouteName === 'RundownCommandEditor') this.close();
		},
		fetchCategories() {
			const params = {
				page: 1,
				limit: 1000,
				order_by: 'name',
				sort_by: 'asc',
				type: 'template',
			};
			const callback = (response) => {
				const categories = response.data.data;
				this.categories = categories;
				const all = {
					id: -10,
					name: 'All',
				};
				this.categories.unshift(all);
			};
			const errorCallback = () => {};
			categoriesApi.getList(params, callback, errorCallback);
		},
		selectedCategory(category) {
			this.keyword = '';
			if (category.id === this.categoryId) {
				this.categoryId = -10;
				this.fetch(true);
				this.isSelectedCategory = false;
				return;
			}
			this.isSelectedCategory = true;
			this.categoryId = category.id;
			this.fetch(true);
		},
		goFavorite() {
			if (this.tab === 'favorite') {
				this.tab = 'all';
				this.categoryId = -10;
			} else {
				this.tab = 'favorite';
				this.orderBy = 'created_at';
			}
		},
		goStore() {
			if (this.tab === 'store') {
				this.tab = 'all';
			} else {
				this.tab = 'store';
			}
		},
		showModalName(str) {
			return elpisisString(str);
		},
		sortAlphabetical() {
			this.sortBy = 'asc';
			this.orderBy = 'name';
			if (this.tab === 'favorite') this.tab = 'all';
		},
		sortRecent() {
			this.sortBy = 'desc';
			this.orderBy = 'created_at';
			if (this.tab === 'favorite') this.tab = 'all';
		},
		openModalAssignUser(data) {
			this.isShowAssign = true;
			this.dataMediaToAssign = data;
		},
		insertTemplate(template) {
			const index = this.items.findIndex(({ id }) => id === template.id);
			if (index === -1) {
				this.items.unshift(template);
			} else {
				this.$set(this.items, index, template);
			}
		},
		setSettingsData() {
			this.isFetching = true;
			const callback = (response) => {
				const user = response.data;
				const settings = JSON.parse(user.settings);
				if (settings) {
					const settingsString = user.settings;
					const settings = JSON.parse(settingsString);
					this.settings = settings;
					this.isEnableAdvance = settings && settings.is_enable_advance_layout ? duplicateVar(settings.is_enable_advance_layout) : false;
					this.isEnableDummy = settings && settings.is_enable_dummy_item_data ? duplicateVar(settings.is_enable_dummy_item_data) : false;
					this.isEnableAllPreview = settings && settings.is_enable_all_preview ? duplicateVar(settings.is_enable_all_preview) : false;
					this.isEnableShowLogo = settings && settings.is_enable_show_logo ? duplicateVar(settings.is_enable_show_logo) : false;
					this.isShowTour = settings && settings.is_tour_visible ? duplicateVar(settings.is_tour_visible) : false;
					this.lastCategoryTemplate = settings && settings.last_category_template ? duplicateVar(settings.last_category_template) : 0;
					this.lastKeywordTemplate = settings && settings.last_keyword_template ? duplicateVar(settings.last_keyword_template) : '';
					this.lastCategoryGallery = settings && settings.last_category_gallery ? duplicateVar(settings.last_category_gallery) : 0;
					this.lastKeywordGallery = settings && settings.last_keyword_gallery ? duplicateVar(settings.last_keyword_gallery) : '';
					if (this.lastCategoryTemplate !== 0) {
						this.category = this.lastCategoryTemplate;
						this.categoryId = this.lastCategoryTemplate;
					} else {
						this.category = 'all';
					}
					if (this.lastKeywordTemplate) {
						this.keyword = this.lastKeywordTemplate;
					} else {
						this.keyword = '';
					}
					this.fetch();
				} else {
				// @TODO: catch variable user setting if setting is undefined
					const settingsString = user.settings;
					const settings = JSON.parse(settingsString);
					this.settings = settings;
					this.isEnableAdvance = 0;
					this.isEnableDummy = 0;
					this.isEnableAllPreview = 0;
					this.isEnableShowLogo = 0;
					this.lastCategoryTemplate = this.categoryId;
					this.lastKeywordTemplate = '';
					this.lastCategoryGallery = 0;
					this.lastKeywordGallery = '';
					this.isShowTour = false;
					this.fetch();
					this.isFetching = false;
				}
			};
			const errorCallback = (e) => {
				const message = getAxiosErrorMessage(e);
				this.$notify({
					group: 'app',
					type: 'error',
					title: 'Profile',
					text: message,
				});
			};
			authApi.getProfile(callback, errorCallback);
		},
		updateSettingProfile() {
			this.settings.last_category_template = this.categoryId;
			this.settings.last_keyword_template = this.keyword;
			const paramsSettings = { settings: JSON.stringify(this.settings) };
			const callback = (response) => {
				const user = response.data;
				this.setUser(user);
			};
			const errorCallback = (e) => {
				const message = getAxiosErrorMessage(e);
				this.$notify({
					group: 'app',
					type: 'error',
					title: this.$t('Update Profile'),
					text: message,
				});
			};
			authApi.updateProfile(paramsSettings, callback, errorCallback);
		},
		clearThumbnail(payload) {
			const itemKey = `thumbnail_template_${payload.id}`;
			localforage.getItem(itemKey).then(() => {
				localforage.removeItem(itemKey);
			});
		},
		scroll_left() {
			const content = document.querySelector('.scrolling-horizontal-menu');
			content.scrollLeft -= 100;
		},
		scroll_right() {
			const content = document.querySelector('.scrolling-horizontal-menu');
			content.scrollLeft += 100;
		},
		dateFormat(date) {
			return dateFormat(date, 'DD/MM/YYYY HH:mm A');
		},
		filterByAdmin() {
			this.isByAdmin = !this.isByAdmin;
			this.fetch(true);
		},
		onScrolling(e) {
			const mouseWheel = this.$refs.scrollCategoryTemplate ? this.$refs.scrollCategoryTemplate : '';
			const race = 80; // How many pixels to scroll
			if (e.deltaY > 0) { // Scroll right
				mouseWheel.scrollLeft += race;
			} else { // Scroll left
				mouseWheel.scrollLeft -= race;
				e.preventDefault();
			}
		},
	},
	computed: {
		...mapGetters({
			user: 'user',
			isSuperAdmin: 'isSuperAdmin',
		}),
		mediaType() {
			let type = 'image';
			if (this.mediaFile && this.mediaFile.type.includes('video')) {
				type = 'video';
			}
			return type;
		},
		activeRouteName() {
			return this.$route.name;
		},
		activeTemplate() {
			return this.previewTemplate;
		},
		activeLottie() {
			const filePath = this.selected && this.selected.file_path ? this.selected.file_path : '';
			return filePath;
		},
		filteredItem() {
			return this.items;
		},
		userUploadTemplates() {
			const settings = this.user && this.user.settings ? JSON.parse(this.user.settings) : null;
			const userSubscription = settings && settings.subscription ? settings.subscription : null;
			const uploadTemplatesSetting = userSubscription && userSubscription.upload_templates ? userSubscription.upload_templates : null;
			const isUploadTemplatesEnable = uploadTemplatesSetting && uploadTemplatesSetting.is_enabled ? uploadTemplatesSetting.is_enabled : false;
			return isUploadTemplatesEnable;
		},
	},
	destroyed() {
	},
	created() {
		const roomId = 'template';
		this.$socket.client.emit('join', roomId);
		this.fetchCategories();
		this.setSettingsData();
	},
	mounted() {
		// scroll horizontal with scroll wheel
		const mouseWheel = this.$refs.scrollCategoryTemplate ? this.$refs.scrollCategoryTemplate : '';
		mouseWheel.addEventListener('wheel', this.onScrolling);
	},
	watch: {
		tab() {
			this.fetch(true);
		},
		sortBy() {
			this.fetch(true);
		},
		categoryId() {
			this.updateSettingProfile();
		},
		user() {
			if (this.user) {
				// this.setSettingsData();
			}
		},
	},
};
</script>
